import { MapLocation } from 'common/constants'

export interface MyLocationState {
  latitude: number
  longitude: number
  clicked: boolean
}

const initialState: MyLocationState = {
  latitude: 0,
  longitude: 0,
  clicked: false,
}

const INIT = 'map/myLocation/INIT'
const SET = 'map/myLocation/SET'

export const initMyLocation = () => {
  return {
    type: INIT,
  }
}

export const setMyLocation = (location: MapLocation) => {
  const state = {
    ...location,
    clicked: true,
  }
  return {
    state,
    type: SET,
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case INIT:
      return {
        ...initialState,
      }
    case SET:
      return {
        ...action.state,
      }

    default:
      return state
  }
}

export default reducer
